<template>
  <transition name="fade">
    <div class="modal-mask" v-if="show">
      <div
        class="modal fade"
        :class="{ show: show, 'd-block': show }"
        id="psrModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="psrModal"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ $t('psr') }}</h5>
              <button type="button" class="btn-close text-dark" @click="salvar" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-12">
                  <span>{{ $t('howDoYouFeelToday') }}</span>
                  <div class="text-sm my-3">
                    10 - {{ $t('completelyRecovered') }} <br />
                    9 -<br />
                    8 - {{ $t('veryVeryWellRecovered') }} <br />
                    7 -<br />
                    6 - {{ $t('veryGoodRecovery') }} <br />
                    5 - {{ $t('goodRecovery') }} <br />
                    4 -<br />
                    3 - {{ $t('moderateRecovery') }} <br />
                    2 - {{ $t('veryLittleRecovery') }} <br />
                    1 - {{ $t('noRecovery') }}
                  </div>
                </div>
                <div class="col-12">
                  <input
                    class="form-control"
                    type="text"
                    required
                    v-maska="'##'"
                    placeholder="{{ $t('enterYourGrade') }}"
                    v-model="state.nota"
                  />
                  <span class="ms-3 text-error text-danger" v-if="v$.nota.$error">{{
                    $t('gradeRequired')
                  }}</span>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn bg-gradient-primary" @click.prevent="salvar">
                {{ $t('save') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { reactive, onMounted, ref, inject } from 'vue'
import { useStore } from 'vuex'
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

export default {
  name: 'pse-modal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const swal = inject('$swal')
    // const emit = defineEmits(['closeModal'])
    const store = useStore()
    onMounted(() => {
      store.commit('SET_SPLASH_SCREEN', false)
    })

    // let modalidadeSelecionadaId = ref('0')

    const state = reactive({
      nota: '',
    })

    const fechaPsrModal = () => {
      window.localStorage.setItem('psr', state.nota)
      emit('fechaPsrModal')
    }

    function salvar() {
      validate()
      let nota = parseInt(state.nota)
      if (nota > 0 && nota < 11) {
        window.localStorage.setItem('psr', state.nota)
        emit('fechaPsrModal')
      }
    }

    const validate = async () => {
      const result = await v$.value.$validate()
      return result
    }

    const rules = {
      nota: { required },
    }

    const v$ = useVuelidate(rules, state)

    return {
      state,
      salvar,
      fechaPsrModal,
      v$,
    }
  },
}
</script>
